/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { withTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

const InfoDisplay = ({ t, i18n }) => {
  const fines = useSelector((state) => state.app.fines)

  const getInfoText = () => {
    try {
      let fullPaymentFines = getFullPaymentFines()
      let finesString = fullPaymentFines.length === 1 ? fullPaymentFines[0] : fullPaymentFines.join(', ')
      return i18n.language === 'en'
        ? `Fine ${finesString} has been added but must be paid in full.`
        : `L'amende ${finesString} a été ajoutée, mais elle doit être payée en entier.`
    } catch (err) {
      console.log(err)
    }
  }

  const getFullPaymentFines = () => {
    return fines
      .filter((fine) => {
        return fine.paymentAmountFull === 'final'
      })
      .map((fine) => fine.fineNumber)
  }

  return (
    getFullPaymentFines().length > 0 && (
      <div class="blockquote-alert" role="alert">
        <p>
          <i class="fa fa-info-circle" aria-hidden="true"></i> {getInfoText()}
        </p>
      </div>
    )
  )
}

export default withTranslation('common')(InfoDisplay)
